var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-input',{class:_vm.$style.input,attrs:{"value":_vm.value,"decimalSeparator":2},on:{"input":_vm.handleChange}})}
var staticRenderFns = []

export { render, staticRenderFns }